<template>
  <div class="entruproce">
    <div class="top between">
      <div class="carditem center">
        <div><img src="../../../assets/entrust/adv1.png" /></div>
        <div class="texts">
          <div class="t_tit">安全</div>
          <div class="t_des">律观网接案律师全部已通过实名认证</div>
        </div>
      </div>

      <div class="carditem center">
        <div><img src="../../../assets/entrust/adv2.png" /></div>
        <div class="texts">
          <div class="t_tit">免费</div>
          <div class="t_des">免费提交案件，律师免费为您分析案情</div>
        </div>
      </div>

      <div class="carditem center">
        <div><img src="../../../assets/entrust/adv3.png" /></div>
        <div class="texts">
          <div class="t_tit">省钱</div>
          <div class="t_des">律师自主协商，更经济更透明</div>
        </div>
      </div>
      <div class="carditem center">
        <div><img src="../../../assets/entrust/adv4.png" /></div>
        <div class="texts">
          <div class="t_tit">海量</div>
          <div class="t_des">多位专业律师为您提供可行诉讼方案</div>
        </div>
      </div>
    </div>

    <div class="botm">
      <sec-title
        Text="委托流程"
        desc-text="5小步，轻松使用律观网案件委托"
        class="text_center"
      />
      <div class="prcelis between">
        <div class="precs_item">
          <div class="precsimg">
            <img
              src="../../../assets/entrust/precs_bg1.png"
              class="precsbgimg"
            />
            <img src="../../../assets/entrust/precs1.png" />
          </div>
          <div class="pre_te">发布案件委托</div>
        </div>

        <div class="pre_line"></div>

        <div class="precs_item">
          <div class="precsimg">
            <img
              src="../../../assets/entrust/precs_bg2.png"
              class="precsbgimg"
            />
            <img src="../../../assets/entrust/precs2.png" />
          </div>
          <div class="pre_te">律观网通知</div>
        </div>

        <div class="pre_line"></div>

        <div class="precs_item">
          <div class="precsimg">
            <img
              src="../../../assets/entrust/precs_bg3.png"
              class="precsbgimg"
            />
            <img src="../../../assets/entrust/precs3.png" />
          </div>
          <div class="pre_te">查看回复</div>
        </div>

        <div class="pre_line"></div>

        <div class="precs_item">
          <div class="precsimg">
            <img
              src="../../../assets/entrust/precs_bg4.png"
              class="precsbgimg"
            />
            <img src="../../../assets/entrust/precs4.png" />
          </div>
          <div class="pre_te">选定意向律师</div>
        </div>

        <div class="pre_line"></div>

        <div class="precs_item">
          <div class="precsimg">
            <img
              src="../../../assets/entrust/precs_bg5.png"
              class="precsbgimg"
            />
            <img src="../../../assets/entrust/precs5.png" />
          </div>
          <div class="pre_te">签合同委托</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "../../home/components/secTitle";
export default {
  components: {
    secTitle,
  },
};
</script>

<style lang="scss" scope>
.entruproce {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .top {
    .carditem {
      width: 280px;
      height: 140px;
      box-shadow: 0px 0px 18px 3px rgba(56, 56, 56, 0.08);
      border-radius: 10px;
      background-color: #fff;
      .texts {
        width: 140px;
        margin-left: 18px;
        .t_tit {
          font-size: 20px;
          color: #0465ea;
          line-height: 20px;
        }
        .t_des {
          margin-top: 10px;
          font-size: 14px;
          color: #333333;
          line-height: 23px;
        }
      }
    }
  }
  .botm {
    margin-top: 50px;
    .prcelis {
      .precs_item {
        text-align: center;
        .precsimg {
          margin-bottom: 19px;
          position: relative;
          .precsbgimg {
            position: absolute;
            top: -35px;
            left: 8px;
            width: 56px;
            height: 82px;
            border-radius: 0;
          }
          img {
            position: relative;
            z-index: 1;
            width: 57px;
            height: 57px;
            border-radius: 50%;
          }
        }
        .pre_te {
          font-size: 18px;
          color: #333333;
          line-height: 30px;
        }
      }
      .pre_line {
        border-top: 1px #dadada dashed;
        width: 122px;
        position: relative;
        top: -20px;
      }
    }
  }
}
</style>